import React, { useState } from 'react';
import axios from '../axios.jsx';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';
import Swal from 'sweetalert2';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.post('/login', { username, password });

      if (res.data.Login) {
        Swal.fire({
          title: 'Bienvenido',
          text: res.data.username,
          icon: 'success',
          confirmButtonText: 'Cool',
          timer: 800,
        });

        sessionStorage.setItem("username", res.data.username);
        sessionStorage.setItem("usernivel", res.data.nivel);

        login(res.data.username);
        navigate('/app', { replace: true });
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Usuario o contraseña incorrectos',
          icon: 'error',
          confirmButtonText: 'Intentar de nuevo'
        });
      }

    } catch (error) {
      Swal.fire({
        title: 'Error de conexión',
        text: 'No se pudo conectar con el servidor',
        icon: 'warning',
        confirmButtonText: 'Ok'
      });
    }
  };

return (
  <div className="d-flex align-items-center justify-content-center" style={{ flex: 1, minHeight: '100%', padding: '2rem 0' }}>
    <div style={{ width: '100%', maxWidth: '480px' }}>
      <div className="card shadow-sm border-0" style={{ borderRadius: '12px' }}>
        <div className="card-body p-5">

          <h2 className="text-center mb-1 fw-bold" style={{ color: '#1a1a2e' }}>
            Iniciar sesión
          </h2>
          <p className="text-center text-muted mb-4" style={{ fontSize: '0.9rem' }}>
            Sistema de Alerta Temprana en Salud
          </p>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="username" className="form-label fw-semibold">
                Usuario
              </label>
              <input
                type="text"
                className="form-control form-control-lg"
                id="username"
                placeholder="Nombre de usuario"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={{ borderRadius: '8px' }}
              />
            </div>

            <div className="mb-4">
              <label htmlFor="password" className="form-label fw-semibold">
                Contraseña
              </label>
              <input
                type="password"
                className="form-control form-control-lg"
                id="password"
                placeholder="••••••••"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ borderRadius: '8px' }}
              />
            </div>

            <div className="d-grid">
              <button
                type="submit"
                className="btn btn-lg"
                style={{
                  backgroundColor: ' #28b6ea',
                  borderColor: '#28b6ea',
                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: '600',
                  letterSpacing: '0.5px'
                }}
              >
                Ingresar
              </button>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
);
};

export default Login;
